<template>
  <div class="content">
    <LeftMenuVue></LeftMenuVue>
    <MainComponentVue></MainComponentVue>
  </div>
</template>

<script>
import LeftMenuVue from '@/components/LeftMenuVue.vue'
import MainComponentVue from '@/components/main/MainComponentVue.vue'

export default {
  components: {
    LeftMenuVue,
    MainComponentVue
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/main/ContentVue.vue